export const endpoints = {
  searchExperienceTransfer: 'experienceTransfer/search',
  deleteExperienceTransfer: 'experienceTransfer'
};
